import { render, staticRenderFns } from "./LanderHeading.vue?vue&type=template&id=256c4d62&scoped=true&"
import script from "./LanderHeading.vue?vue&type=script&lang=js&"
export * from "./LanderHeading.vue?vue&type=script&lang=js&"
import style0 from "./LanderHeading.vue?vue&type=style&index=0&id=256c4d62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c4d62",
  null
  
)

export default component.exports